import axios from "axios";
import { InvalidTokenError } from "core/utils";
import { isNil } from "lodash";
import identity from "lodash/identity";

const onFulfilled = identity;

const onRejected = async (error: any) => {
	const errorMessage = "Por el momento no es posible procesar tu solicitud. Te sugerimos intentar más tarde";

	switch (error?.response?.status) {
		case 400: {
			let data = error.response.data;
			if (data instanceof Blob) {
				data = JSON.parse(await data.text());
			}
			throw new Error(data.title || data.message || "Petición inválida.");
		}
		case 401:
		case 403:
			// error instanceof InvalidTokenError
			throw new InvalidTokenError("Sesión o token no válidos.");
		case 404:
			throw new Error(`${error.config.url} no existe.`);
		case 429:
			throw new Error("Excediste el número máximo de peticiones permitidas. Te sugerimos intentar más tarde");
		case 500: {
			let serverMessage = error.response.data.message;
			if (isNil(serverMessage) || serverMessage.startsWith("Por el momento")) {
				serverMessage = errorMessage;
			}
			throw new Error(serverMessage);
		}
		default:
			throw new Error(errorMessage);
	}
};

export const axiosClient = axios.create({ headers: { "Content-Type": "application/json" } });

axiosClient.interceptors.response.use(onFulfilled, onRejected);